import React from 'react';
import { Button } from "@/components/ui/button";
import { Heart, Eye } from "lucide-react";

interface GlobalProductCardControlsProps {
  productId: string;
  isFavorite: boolean;
  onToggleFavorite: (e: React.MouseEvent) => void;
  onQuickView: (e: React.MouseEvent) => void;
  className?: string;
}

export const GlobalProductCardControls: React.FC<GlobalProductCardControlsProps> = ({
  productId,
  isFavorite,
  onToggleFavorite,
  onQuickView,
  className = ""
}) => {
  return (
    <div className={`absolute top-2 right-2 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${className}`}>
      {/* Favorite Button */}
      <Button
        size="sm"
        variant="outline"
        className={`group/btn w-10 h-10 p-0 bg-background/80 backdrop-blur-sm hover:bg-background transition-standard ${isFavorite ? 'text-favorite' : 'text-primary hover:text-favorite'}`}
        onClick={onToggleFavorite}
        aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      >
        <Heart className="w-4 h-4 transition-standard group-hover/btn:fill-current" fill={isFavorite ? 'currentColor' : 'none'} />
      </Button>

      {/* Quick View Button */}
      <Button
        size="sm"
        variant="outline"
        className="group/btn w-10 h-10 p-0 bg-background/80 backdrop-blur-sm hover:bg-background transition-standard text-foreground/70 hover:text-info"
        onClick={(e) => {
          console.log('🔍 GlobalProductCardControls: Eye icon clicked for product:', productId);
          onQuickView(e);
        }}
        aria-label="Quick view"
      >
        <Eye className="w-4 h-4" />
      </Button>
    </div>
  );
};